import type { MessageKey } from "@gioia365/i18n";
import type { Translate } from "../../i18n/locale";

// I fusi che «Calendario, fuso e lingua» offre: le otto zone europee dei mock-up, con il nome del Paese e della
// città nel catalogo. Il server accetta ogni fuso IANA (`timeZoneSchema`): un'azienda già salvata con un altro
// non lo perde, perché quello salvato compare sempre fra le scelte (`timeZoneOptions`).
const LISTED = [
  { id: "Europe/Rome", label: "calendar.zones.rome" },
  { id: "Europe/Zurich", label: "calendar.zones.zurich" },
  { id: "Europe/Paris", label: "calendar.zones.paris" },
  { id: "Europe/Berlin", label: "calendar.zones.berlin" },
  { id: "Europe/Madrid", label: "calendar.zones.madrid" },
  { id: "Europe/London", label: "calendar.zones.london" },
  { id: "Europe/Lisbon", label: "calendar.zones.lisbon" },
  { id: "Europe/Vienna", label: "calendar.zones.vienna" },
] as const satisfies ReadonlyArray<{ id: string; label: MessageKey }>;

/** «Italia (Roma)» per un fuso dell'elenco, il suo nome tecnico per ogni altro. */
export function timeZoneName(t: Translate, id: string): string {
  const listed = LISTED.find((zone) => zone.id === id);
  return listed ? t(listed.label) : id;
}

/** Le scelte del fuso: «Italia (Roma) · Europe/Rome»; un fuso salvato fuori dall'elenco va in testa, col suo nome. */
export function timeZoneOptions(t: Translate, saved: string): Array<{ value: string; label: string }> {
  const options = LISTED.map((zone) => ({ value: zone.id, label: t("calendar.zone.entry", { name: t(zone.label), id: zone.id }) }));
  return LISTED.some((zone) => zone.id === saved) ? options : [{ value: saved, label: saved }, ...options];
}
